export default __webpack_public_path__ + "7b2a1ccfe68f425d8b81ca3b5f45730c.svg";